<script setup lang="ts">
  // contentsTypeによって、ライブ、スケジュール、アーカイブカードを表示するコンポーネント

  import { LiveInfo } from "~/entities/LiveInfo";
  import { STREAMING_CONTENT_TYPE } from "~/consts/contentsConfig";

  interface Props {
    liveInfo: LiveInfo;
    loading?: boolean;
    isFeatured?: boolean;
  }
  const props = defineProps<Props>();

  const isLive = computed<boolean>(() => props.liveInfo.contentsType === STREAMING_CONTENT_TYPE.LIVE);
  const isSchedule = computed<boolean>(() => props.liveInfo.contentsType === STREAMING_CONTENT_TYPE.SCHEDULE);
  const isArchive = computed<boolean>(() => props.liveInfo.contentsType === STREAMING_CONTENT_TYPE.ARCHIVE);
</script>

<template>
  <OrganismsLiveCard v-if="loading" :live-info="liveInfo" />
  <OrganismsLiveCard v-else-if="isLive" :live-info="liveInfo" :is-featured="isFeatured" />
  <OrganismsLiveScheduleCard v-else-if="isSchedule" :live-info="liveInfo" :is-featured="isFeatured" />
  <OrganismsLiveArchiveCard v-else-if="isArchive" :live-info="liveInfo" :loading="loading" :is-featured="isFeatured" />
</template>
